import { Box, List, Typography, styled } from '@mui/material'

export const TraderTextStyle = styled(Typography)({
  color: '#FFF',
  leadingTrim: 'both',
  textEdge: 'cap',
  fontFamily: 'Nunito',
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: 'normal'
})

export const TraderHeaderContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '30px'
})

export const TraderHeaderSwitchContainer = styled(Box)({
  display: 'flex',
  color: 'white',
  alignItems: 'center'
})

export const TradingAccountTextItem = styled(Typography)({
  color: '#FFF',
  leadingTrim: 'both',
  textEdge: 'cap',
  fontFamily: 'Nunito',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: 'normal'
})

export const TraderTradingAccountList = styled(List)({
  display: 'flex',
  gap: '22px',
  marginTop: '19px',
  flexDirection: 'column',
  background: 'transparent',
  padding: '0px',
  height: '340px',
  maxHeight: '340px',
  overflowY: 'auto'
})
